var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "sendModal",
          attrs: {
            title: _vm.$t("stores::order::deliver_solutions"),
            visible: _vm.isSendModalShow,
            width: "800px",
            bodyHeight: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSendModalShow = $event
            },
            closed: _vm.closed,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "step-wrap" },
                _vm._l(_vm.steps, function (item, index) {
                  return _c("div", { key: index, staticClass: "step-item" }, [
                    _vm.step >= index
                      ? _c("i", { staticClass: "el-icon-success" })
                      : _c("span", { staticClass: "step-number" }, [
                          _vm._v(_vm._s(index + 1)),
                        ]),
                    _c(
                      "span",
                      {
                        staticClass: "step-title",
                        class: { active: _vm.step >= index },
                      },
                      [_vm._v(_vm._s(_vm.$t("stores::order::" + item)))]
                    ),
                    index != _vm.steps.length - 1
                      ? _c("div", {
                          staticClass: "step-line",
                          class: { active: _vm.step > index },
                        })
                      : _vm._e(),
                  ])
                }),
                0
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === 0,
                      expression: "step === 0",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "info-wrap" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("stores::order::deliver_fee_plan")) + "："
                      ),
                    ]),
                    _c("span", { staticStyle: { color: "#ff4041" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$dataCheck(_vm.isSendModalData.shippingTitle)
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "content-title" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("stores::order::delivery_info")) + " "
                    ),
                  ]),
                  _c("z-table", {
                    ref: "sendTable",
                    staticClass: "sendTable",
                    attrs: {
                      data: _vm.isSendModalData.orderItems,
                      columns: _vm.isSendModalColumns,
                      selection: true,
                      pagination: false,
                    },
                    on: { "selection-change": _vm.sendSelectChange },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              { staticClass: "goods-info" },
                              [
                                _c("el-image", {
                                  staticClass: "order-item-img",
                                  attrs: {
                                    src: row.imageUrl,
                                    "preview-src-list": [row.imageUrl],
                                    alt: "",
                                  },
                                }),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: row.title,
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "order-item-title" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(row.title) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      { staticClass: "order-item-desc" },
                                      [
                                        _vm._v(
                                          " SPU：" +
                                            _vm._s(_vm.$dataCheck(row.spuId)) +
                                            " | " +
                                            _vm._s(
                                              _vm.$dataCheck(
                                                row.variantOptionValue
                                              )
                                            ) +
                                            _vm._s(
                                              _vm.filterVariant(
                                                row.variantCustomizedOption
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      { staticClass: "order-item-desc" },
                                      [
                                        _vm._v(
                                          "SKU：" +
                                            _vm._s(_vm.$dataCheck(row.skuId))
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "weight",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(row.totalWeight) +
                                "kg/" +
                                _vm._s(_vm.$t("stores::order::item"))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("div", { staticClass: "select-title" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("stores::order::select_goods_total", {
                            x: _vm.totalQuantity,
                          })
                        ) +
                          " " +
                          _vm._s(_vm.totalWeight) +
                          "kg"
                      ),
                    ]),
                    _c("div", { staticClass: "total-goods" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("stores::order::fulfilment_goods", {
                              goodsNum: _vm.isSendModalData.orderItems.length,
                            })
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm.step === 2
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "form-wrap" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "sendModalForm",
                            attrs: {
                              inline: "",
                              rules: _vm.sendModalFormRules,
                              model: _vm.sendModalForm,
                              "label-width": "auto",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("stores::order::fulfilment_type") +
                                    ":",
                                  prop: "id",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "285px" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "system::common::input_holder"
                                      ),
                                      "popper-append-to-body": false,
                                    },
                                    model: {
                                      value: _vm.sendModalForm.id,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.sendModalForm, "id", $$v)
                                      },
                                      expression: "sendModalForm.id",
                                    },
                                  },
                                  _vm._l(_vm.sendOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("stores::order::deliver_time") + ":",
                                  prop: "time",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "285px" },
                                  attrs: {
                                    type: "datetime",
                                    placeholder: _vm.$t(
                                      "stores::order::select_date"
                                    ),
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "picker-options": _vm.pickerOptions,
                                  },
                                  on: { change: _vm.checkTime },
                                  model: {
                                    value: _vm.sendModalForm.time,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.sendModalForm, "time", $$v)
                                    },
                                    expression: "sendModalForm.time",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("stores::order::fulfilment_number") +
                                    ":",
                                  prop: "number",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "660px" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "stores::order::ship_input_fulfilment"
                                    ),
                                  },
                                  model: {
                                    value: _vm.sendModalForm.number,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.sendModalForm, "number", $$v)
                                    },
                                    expression: "sendModalForm.number",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "order-wrap" }, [
                      _c("div", { staticClass: "content-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("stores::order::order_info")) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "order-info-wrap" }, [
                        _c("div", { staticClass: "order-info" }, [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c("el-image", {
                                staticClass: "order-info-img",
                                attrs: { src: _vm.sendDataList[0].imageUrl },
                              }),
                              _vm.sendDataList.length > 1
                                ? [
                                    _c("div", { staticClass: "border-line" }),
                                    _c("div", { staticClass: "border-line" }),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c("div", [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("stores::order::order_number")) +
                                  "：" +
                                  _vm._s(_vm.orderDetail.orderNo)
                              ),
                            ]),
                            _c("p", { staticClass: "tips" }, [
                              _vm._v(
                                _vm._s(_vm.$t("stores::order::total_weight")) +
                                  "：" +
                                  _vm._s(_vm.totalWeight) +
                                  "kg"
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "order-right" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("stores::order::all_goods_number", {
                                    number: _vm.sendDataList.length,
                                  })
                                )
                              ),
                            ]),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    _vm.unfold = !_vm.unfold
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.unfold
                                        ? _vm.$t("system::common::btn::pick_up")
                                        : _vm.$t("system::common::btn::unfold")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.unfold,
                              expression: "unfold",
                            },
                          ],
                        },
                        [
                          _c("z-table", {
                            staticClass: "selectTable",
                            attrs: {
                              data: _vm.sendDataList,
                              columns: _vm.isSendModalColumns,
                              selection: false,
                              pagination: false,
                              "show-header": false,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "goods-info" },
                                        [
                                          _c("el-image", {
                                            staticClass: "order-item-img",
                                            attrs: {
                                              src: row.imageUrl,
                                              "preview-src-list": [
                                                row.imageUrl,
                                              ],
                                              alt: "",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: row.title,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "order-item-title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(row.title) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "order-item-desc",
                                                },
                                                [
                                                  _vm._v(
                                                    " SPU：" +
                                                      _vm._s(
                                                        _vm.$dataCheck(
                                                          row.spuId
                                                        )
                                                      ) +
                                                      " | " +
                                                      _vm._s(
                                                        _vm.$dataCheck(
                                                          row.variantOptionValue
                                                        )
                                                      ) +
                                                      _vm._s(
                                                        _vm.filterVariant(
                                                          row.variantCustomizedOption
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "order-item-desc",
                                                },
                                                [
                                                  _vm._v(
                                                    "SKU：" +
                                                      _vm._s(
                                                        _vm.$dataCheck(
                                                          row.skuId
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "weight",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        _vm._s(row.totalWeight) +
                                          "kg/" +
                                          _vm._s(_vm.$t("stores::order::item"))
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2368783584
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step !== 1,
                      expression: "step !== 1",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "content-title" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("stores::order::customer_info")) + " "
                    ),
                  ]),
                  _c("div", { staticClass: "customer-info" }, [
                    _c("div", { staticClass: "customer-info-item" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("stores::order::receiver")) +
                          ": " +
                          _vm._s(_vm.isSendModalData.firstName) +
                          " " +
                          _vm._s(_vm.isSendModalData.lastName) +
                          " "
                      ),
                    ]),
                    _c("div", { staticClass: "customer-info-item" }, [
                      _vm._v(
                        _vm._s(_vm.$t("stores::order::zip")) +
                          ":" +
                          _vm._s(_vm.isSendModalData.zip)
                      ),
                    ]),
                    _c("div", { staticClass: "customer-info-item" }, [
                      _vm._v(
                        _vm._s(_vm.$t("stores::order::email")) +
                          ":" +
                          _vm._s(_vm.isSendModalData.email)
                      ),
                    ]),
                    _c("div", { staticClass: "customer-info-item" }, [
                      _vm._v(
                        _vm._s(_vm.$t("stores::order::phone")) +
                          ":" +
                          _vm._s(_vm.isSendModalData.phone)
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "customer-info-item",
                        staticStyle: { "max-width": "67%" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("stores::order::address")) +
                            ":" +
                            _vm._s(_vm.isSendModalData.country) +
                            " " +
                            _vm._s(_vm.isSendModalData.province) +
                            " " +
                            _vm._s(_vm.isSendModalData.city) +
                            " " +
                            _vm._s(_vm.isSendModalData.address1) +
                            " " +
                            _vm._s(_vm.isSendModalData.address2) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === 1,
                      expression: "step === 1",
                    },
                  ],
                },
                [
                  _vm.totalWeight > 0
                    ? [
                        _vm.bindLogistics
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              _vm._l(_vm.deliverList, function (item) {
                                return _c(
                                  "div",
                                  { key: item.id },
                                  [
                                    item.status !== 0
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "content-title" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t(item.key)) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "z-table",
                                            {
                                              directives: [
                                                {
                                                  name: "loading",
                                                  rawName: "v-loading",
                                                  value: _vm.deliveryLoading,
                                                  expression: "deliveryLoading",
                                                },
                                              ],
                                              attrs: {
                                                data: item.list,
                                                columns: _vm.deliveryColumns,
                                                pagination: false,
                                                customEmpty: true,
                                                "empty-text": _vm.$t(
                                                  "stores::order::ship_inside"
                                                ),
                                                "max-height": 150,
                                                border: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "cname",
                                                    fn: function (ref) {
                                                      var row = ref.row
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.cname
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                        Math.min.apply(
                                                          Math,
                                                          item.list.map(
                                                            function (i) {
                                                              return i.totalFee
                                                            }
                                                          )
                                                        ) === row.totalFee
                                                          ? _c(
                                                              "el-tag",
                                                              {
                                                                attrs: {
                                                                  type: "danger",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "stores::order::recommend"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "shippingFee",
                                                    fn: function (ref) {
                                                      var row = ref.row
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.shippingFee
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "otherFee",
                                                    fn: function (ref) {
                                                      var row = ref.row
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.otherFee
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "totalFee",
                                                    fn: function (ref) {
                                                      var row = ref.row
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.totalFee
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "deliveryDays",
                                                    fn: function (ref) {
                                                      var row = ref.row
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.deliveryDays
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "selection",
                                                    fn: function (ref) {
                                                      var row = ref.row
                                                      return [
                                                        _c("el-checkbox", {
                                                          attrs: {
                                                            disabled: _vm.planId
                                                              ? row.id !=
                                                                _vm.planId
                                                              : false,
                                                          },
                                                          on: {
                                                            change: function (
                                                              bool
                                                            ) {
                                                              return _vm.selectPlan(
                                                                row.id,
                                                                bool,
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "empty" },
                                                  slot: "empty",
                                                },
                                                [
                                                  item.id === 28
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "stores::order::ship_inside"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : item.id === 52
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "stores::order::ship_auth"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toD4xAuth(
                                                                      item.url
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "stores::order::重新授权"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        !_vm.bindLogistics
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  padding: "20px",
                                },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("stores::order::not_fulfilment")
                                    )
                                  ),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      "margin-top": "10px；margin-right: 10px",
                                    },
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        _vm.dialogVisible = true
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "stores::order::bind_fulfilment"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-top": "10px" },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.sendGoods },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("stores::order::to_deliver")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm.totalWeight === 0
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            padding: "20px",
                          },
                        },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("stores::order::weigth_zero"))
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.backStep } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.step
                        ? _vm.$t("stores::order::prev_step")
                        : _vm.$t("system::common::btn::cancel")
                    ) +
                    " "
                ),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.sendLoading },
                  on: { click: _vm.submitConfirmSend },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.step === 2
                          ? _vm.$t("stores::order::confirm_delivery")
                          : _vm.$t("stores::order::next_step")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c("logisticsDialog", {
        on: { closeDialog: _vm.closeDialog },
        model: {
          value: _vm.dialogVisible,
          callback: function ($$v) {
            _vm.dialogVisible = $$v
          },
          expression: "dialogVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }